"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterFormProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _lodash = _interopRequireWildcard(require("lodash"));

var _store = require("store");

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _selectors = require("../../../store/filters/value/selectors");

var _actions = require("../../../store/filters/value/actions");

var _actions2 = require("../../../store/filters/options/actions");

var _FilterFormContext = require("./FilterFormContext");

var _actions3 = require("../../../store/filters/forms/actions");

var _treeChanges2 = _interopRequireDefault(require("tree-changes"));

var _selectors2 = require("../../../store/filters/forms/selectors");

var _component = require("../../../constants/component");

var _filters = require("../../../constants/filters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FilterFormProvider = function FilterFormProvider(WrappedComponent) {
  var _defineProperty2;

  var FilterFormProvider =
  /*#__PURE__*/
  function (_Component) {
    _inherits(FilterFormProvider, _Component);

    _createClass(FilterFormProvider, [{
      key: "getStoredProps",
      value: function getStoredProps(props) {
        var _this2 = this;

        return _lodash["default"].pickBy(props, function (v, k) {
          return _lodash["default"].includes(_this2.storedProps, k);
        });
      }
    }, {
      key: "isStoredPropsChanged",
      value: function isStoredPropsChanged(props, nextProps) {
        var _treeChanges = (0, _treeChanges2["default"])(props, nextProps),
            changed = _treeChanges.changed;

        for (var i = 0; i < this.storedProps.length; i++) {
          if (changed(this.storedProps[i])) {
            return true;
          }
        }

        return false;
      }
    }, {
      key: "storedProps",
      get: function get() {
        return [_component.PROPS.FILTER_TYPE, _component.PROPS.RELATED_FILTERS, _component.PROPS.LOCALE, _component.PROPS.FILTER_PARAMS // TODO: remove it parameter, use dataSource -> queryParams
        ];
      }
    }]);

    function FilterFormProvider(props) {
      var _this;

      _classCallCheck(this, FilterFormProvider);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterFormProvider).call(this, props));
      var id = (0, _selectors2.getNextId)(_store.store.getState());
      _this.state = {
        id: id
      };
      props.create(id, _this.getStoredProps(props));
      return _this;
    }

    _createClass(FilterFormProvider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var mount = this.props.mount;
        var id = this.state.id;
        mount(id, this.getStoredProps(this.props));
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState, snapshot) {
        var updateProps = this.props.updateProps;
        var id = this.state.id;

        if (this.isStoredPropsChanged(this.props, prevProps)) {
          updateProps(id, this.getStoredProps(this.props));
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var id = this.state.id;
        var unmount = this.props.unmount;
        unmount(id);
      }
    }, {
      key: "render",
      value: function render() {
        var filterType = this.props.filterType;
        var id = this.state.id;
        return _react["default"].createElement(_FilterFormContext.FilterFormContext.Provider, {
          value: {
            formId: id,
            filterType: filterType
          }
        }, _react["default"].createElement(WrappedComponent, _extends({}, this.props, {
          id: id
        })));
      }
    }]);

    return FilterFormProvider;
  }(_react.Component);

  _defineProperty(FilterFormProvider, "propTypes", (_defineProperty2 = {
    showFilterLoader: PropTypes.bool
  }, _defineProperty(_defineProperty2, _component.PROPS.FILTER_TYPE, PropTypes.oneOf(_lodash["default"].values(_filters.FILTER_TYPE))), _defineProperty(_defineProperty2, _component.PROPS.RELATED_FILTERS, PropTypes.arrayOf(PropTypes.oneOf((0, _lodash.values)(_filters.FILTER_TYPE)))), _defineProperty(_defineProperty2, _component.PROPS.FILTER_PARAMS, PropTypes.object), _defineProperty(_defineProperty2, "create", PropTypes.func.isRequired), _defineProperty(_defineProperty2, "mount", PropTypes.func.isRequired), _defineProperty(_defineProperty2, "unmount", PropTypes.func.isRequired), _defineProperty(_defineProperty2, "updateProps", PropTypes.func.isRequired), _defineProperty2));

  _defineProperty(FilterFormProvider, "defaultProps", {
    showFilterLoader: true
  });

  var mapStateToProps = function mapStateToProps(state, props) {
    return {
      filterValues: (0, _selectors.getValue)(state, props.filterType)
    };
  };

  var mapDispatchToProps = {
    create: _actions3.create,
    mount: _actions3.mount,
    unmount: _actions3.unmount,
    updateProps: _actions3.updateProps,
    setFilter: _actions.set,
    applyFilter: _actions.apply,
    resetFilter: _actions.reset,
    setOptions: _actions2.setOptions
  };
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FilterFormProvider);
};

exports.FilterFormProvider = FilterFormProvider;